import React, {useContext} from "react";
import {ThreadContext} from "../../../context/threadContext";
import Post from "../../Post/Post";
import {useTranslation} from "react-i18next";

const Ratings = () => {
	const {t} = useTranslation();

	const {
		thread,
		ratings, ratingsLoading, hasMoreRatings, loadMoreRatings, fetchRatings
	} = useContext(ThreadContext);

	fetchRatings(true);

	const handleLoadMoreRatings = () => {
		loadMoreRatings();
	}

	return (
		<div>
			{thread && ratings && ratings.length > 0 && (
				<section className="mb-4">
					{ratings.map((rating, index) => (
						<div className="mb-4" key={index}>
							<Post post={rating} postId={rating.thread_rating_id} isRating={true} />
						</div>
					))}

					{hasMoreRatings && (
						<div className="text-center mt-4">
							<button
								onClick={handleLoadMoreRatings}
								className="w-auto px-2 py-1 bg-primary text-sm font-semibold text-white rounded transition hover:bg-red-900"
							>
								{ratingsLoading ? t("loading_content") : t("load_more_replies")}
							</button>
						</div>
					)}
				</section>
			)}
		</div>
	);
}

export default Ratings;